export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 animate-fade-in" data-testid="terms-page">
      <div className="text-xs uppercase tracking-widest text-accent mb-2">Legal</div>
      <h1 className="font-display font-extrabold text-4xl md:text-5xl">Terms of Service</h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="prose prose-neutral max-w-none mt-8 space-y-6 text-base leading-relaxed">
        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">1. The short version</h2>
          <p>
            Florida Sportsman ("we", "us", "the platform") is a community forum and peer-to-peer marketplace for
            Florida sportsmen. Sellers list their own gear; buyers pay through Stripe; we don't own, inspect, or
            ship the items. Use it in good faith, don't break the law, and don't be a jerk.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">2. Your account</h2>
          <p>
            You sign in with Google. You're responsible for keeping your Google account secure and for everything
            posted under your handle. You must be 18 or older to buy or sell.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">3. Content you post</h2>
          <p>
            You keep ownership of the threads, replies, listings, photos and messages you post. By posting, you grant
            us a worldwide, royalty-free license to host, display, and distribute that content on the platform. You
            promise you have the right to post it and that it isn't illegal, infringing, or misleading.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">4. The marketplace</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Sellers are solely responsible for their listings — accuracy, condition, legality, shipping, and returns.</li>
            <li>Buyers pay via Stripe. We are not the merchant of record for the physical goods.</li>
            <li>All firearms, ammunition, and regulated wildlife sales must comply with federal, Florida state, and local law. That includes background checks and FFL transfers where required. We do not enable transfers that skip those rules.</li>
            <li>Protected or restricted species, live wildlife, controlled substances, stolen goods, and anything else illegal to sell in Florida are strictly prohibited.</li>
            <li>Chargebacks, disputes, refunds, and taxes on marketplace transactions are handled through Stripe according to Stripe's terms.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">5. Moderation</h2>
          <p>
            We can remove content, suspend accounts, or refuse service at our discretion — especially for anything
            that breaks the <a href="/rules" className="text-primary underline">Community Rules</a> or the law. Reports
            are reviewed by human moderators when possible.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">6. No warranty</h2>
          <p>
            The platform is provided "as is". We don't guarantee any listing is accurate, any buyer will pay, any
            seller will ship, or any fish story is true. Use your head.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">7. Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, Florida Sportsman is not liable for any indirect, incidental,
            or consequential damages arising from your use of the platform, including losses from marketplace
            transactions between users.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">8. Changes</h2>
          <p>
            We may update these terms. Continued use of the platform after an update means you accept the new terms.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">9. Contact</h2>
          <p>Questions? Reach out through the in-app messaging system to the admin account.</p>
        </section>
      </div>
    </div>
  );
}
